var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content product-output-list"},[_c('SearchFilteredProducts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }